import { createAction, ThunkAction } from '@bigcommerce/data-store';
import { concat, defer, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

// TODO: CHECKOUT-9979 remove this import before delivery
import { resolveB2bAppClientId, resolveB2bBaseUrl } from '../b2b-dev-tools';
import { InternalCheckoutSelectors } from '../checkout';
import { throwErrorAction } from '../common/error';
import { MissingDataError, MissingDataErrorType } from '../common/error/errors';
import { RequestOptions } from '../common/http-request';

import { B2BTokenActionType, LoadB2BTokenAction } from './b2b-token-actions';
import B2BTokenRequestSender from './b2b-token-request-sender';

export default class B2BTokenActionCreator {
    constructor(private _requestSender: B2BTokenRequestSender) {}

    loadB2BToken(
        options?: RequestOptions,
    ): ThunkAction<LoadB2BTokenAction, InternalCheckoutSelectors> {
        return (store) => {
            const state = store.getState();
            const storeConfig = state.config.getStoreConfigOrThrow();
            const { storeHash } = storeConfig.storeProfile;
            // TODO: CHECKOUT-9979 revert to `const { baseUrl: b2bBaseUrl = '', clientId: b2bClientId = '' } = storeConfig.b2bApiSettings ?? {};` before delivery
            const { baseUrl = '', clientId = '' } = storeConfig.b2bApiSettings ?? {};
            const b2bClientId = resolveB2bAppClientId(clientId);
            const b2bBaseUrl = resolveB2bBaseUrl(baseUrl);

            if (!b2bBaseUrl || !b2bClientId) {
                throw new MissingDataError(MissingDataErrorType.MissingB2BConfig);
            }

            const { id: customerId } = state.customer.getCustomerOrThrow();
            const { channelId } = state.checkout.getCheckoutOrThrow();

            return concat(
                of(createAction(B2BTokenActionType.LoadB2BTokenRequested)),
                defer(async () => {
                    const { body } = await this._requestSender.getB2BToken(
                        b2bClientId,
                        customerId,
                        storeHash,
                        channelId,
                        b2bBaseUrl,
                        options,
                    );

                    return createAction(B2BTokenActionType.LoadB2BTokenSucceeded, {
                        token: body.data.token,
                    });
                }),
            ).pipe(
                catchError((error) =>
                    throwErrorAction(B2BTokenActionType.LoadB2BTokenFailed, error),
                ),
            );
        };
    }
}
